import React from 'react'
import AppContentAreaComponent from '../../@b_components/app_content_area/app_content_area.component'

const ContentAreaContainer = function ({...props}) {
  return <AppContentAreaComponent {...props} />
}

export default ContentAreaContainer
